var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper",class:[
    {
      [_vm.classes.container]: _vm.classes.container,
      [_vm.classes.block]: _vm.classes.block,
      'is-page-advice': _vm.isPageAdvice,
    },
  ]},[(_vm.title)?_c('h3',{staticClass:"wrapper__title",class:_vm.classes.title},[_vm._v("\n    "+_vm._s(_vm.title.trim())+"\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.components),function(component,index){return _c('div',{key:index,staticClass:"wrapper__component"},[_c('RenderContent',{key:component?.seoBlockId || index,attrs:{"content":[component]}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }